"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRequestState = void 0;
var HttpRequestState;
(function (HttpRequestState) {
    /**
     * Request has been sent to the endpoint
     */
    HttpRequestState["Sent"] = "sent";
    /**
     * A response has been received from the endpoint
     */
    HttpRequestState["Received"] = "received";
    /**
     * The request was aborted by the caller, regardless
     * of whether a response was received or not
     */
    HttpRequestState["Aborted"] = "aborted";
    /**
     * The request was blocked by the client due to CORS
     */
    HttpRequestState["Blocked"] = "blocked";
    /**
     * The request timed out
     */
    HttpRequestState["Timeout"] = "timeout";
    /**
     * There was a network error sending the request.
     * Note, this is not the same as a 4|5XX response.
     */
    HttpRequestState["Error"] = "error";
})(HttpRequestState || (exports.HttpRequestState = HttpRequestState = {}));
